import * as React from 'react';
import moment from 'moment';

import FiltersComponent from '../../utils/filters';
import { DateSelectFilter, MultiSelectFilter } from '../../utils/FilterTypes';
import { PredefinedDateRanges } from '../../../utils/createPredefinedFilters';
import { useMobilizationStatistics } from './helpers';
import { MobilizationStatisticsTable } from './MobilizationStatisticsTable';
import { defaultDateLimit } from '../../utils/DateFilter';

const defaultFilters = [
    new MultiSelectFilter('Vendor Nickname', 'vendorId', ''),
    new MultiSelectFilter('Outlet', 'branch', ''),
    new MultiSelectFilter('Category', 'category', [], []),
    new DateSelectFilter(
        'TX Period',
        'createdAt',
        '',
        PredefinedDateRanges,
        {
            startDate: moment().startOf('month').toDate(),
            endDate: moment().endOf('month').toDate(),
        },
        defaultDateLimit,
        true
    ),
];
interface Props {
    branchCodes?: string[];
    categories?: unknown;
    fetchToday: (data: Record<string, unknown>) => Promise<unknown[]>;
    fetchRange: (data: Record<string, unknown>) => Promise<unknown[]>;
    fetchSyncDate: (data: Record<string, unknown>) => Promise<unknown>;
    vendors?: unknown[];
}
export const MobilizationStatistics: React.FC<Props> = React.memo(function MobilizationStatistics({
    fetchToday,
    fetchRange,
    fetchSyncDate,
    vendors,
    categories,
    branchCodes,
}) {
    const { filters, applyFilters, refreshTodayResults, todayData, filteredData, syncDate } = useMobilizationStatistics(
        defaultFilters,
        fetchToday,
        fetchRange,
        fetchSyncDate,
        vendors,
        categories,
        branchCodes
    );

    return (
        <>
            <FiltersComponent
                defaultFilters={defaultFilters}
                disableRemove={true}
                extraButtons={[
                    {
                        className: 'wfp-btn ml3',
                        onClick: refreshTodayResults,
                        name: 'Refresh Results',
                    },
                ]}
                filters={filters}
                onApplyFilters={applyFilters}
                withApply={true}
                withIsSelected={true}
                withTimeRangeLimit={true}
            />
            <p style={{ margin: 0, textAlign: 'right' }}>
                <em>
                    <small>Statistics data as of {syncDate}</small>
                </em>
            </p>
            <div className="row">
                <MobilizationStatisticsTable filteredData={filteredData} todayData={todayData} />
            </div>
        </>
    );
});
